import React from 'react'
import { l, Modal } from '@manychat/manyui'

import { formatSupportCutoverEndTime } from './helpers'

interface SupportCutoverModalProps {
  open: boolean
  onClose: () => void
}

export const SupportCutoverModal = ({ open, onClose }: SupportCutoverModalProps) => (
  <Modal
    data-test-id="support-cutover-modal"
    title={l.translate('We’re upgrading our support system.')}
    open={open}
    buttons={[
      {
        onClick: onClose,
        label: l.translate('Close'),
        ['data-test-id']: 'support-cutover-modal-close-btn',
      },
    ]}
    onRequestClose={onClose}
  >
    <p className="p-a-xs">
      {l.translate(
        'Our widget is briefly unavailable while we finish the switch, and we’ll be back at {time}.',
        { time: formatSupportCutoverEndTime() },
      )}
    </p>
  </Modal>
)
